import React from 'react';
import { FileImage } from 'lucide-react';

const InitialMessage = ({ show }) => {
  if (!show) return null;
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="text-center text-gray-500 dark:text-gray-400">
        <FileImage size={64} className="mx-auto mb-4" />
        <p className="text-lg font-semibold">No slide loaded</p>
        <p className="text-sm">Select a slide from the left panel.</p>
      </div>
    </div>
  );
};
export default InitialMessage;
